import React, { forwardRef } from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import InterpreterModeOutlinedIcon from '@mui/icons-material/InterpreterModeOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';
import { ListItemButton, ListItemIcon, ListItemText, useMediaQuery, Collapse } from '@mui/material';
import { useLocation } from 'react-router-dom';
import routes from '../../../Utils/routes';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import { useStyles } from '../styles';
import { ReactComponent as Bookicon } from '../../../Assets/Bookicon.svg';
import { ReactComponent as Homeicon } from '../../../Assets/icons/Home.svg';
import { ReactComponent as Profileicon } from '../../../Assets/icons/Profile.svg';
import { ReactComponent as Feed } from '../../../Assets/icons/Feed.svg';
import { ReactComponent as Events } from '../../../Assets/icons/Events.svg';
import { ReactComponent as Jobs } from '../../../Assets/icons/Job.svg';
import { ReactComponent as MentorShip } from '../../../Assets/icons/MentorShip.svg';
import { ReactComponent as FundRaise } from '../../../Assets/icons/FundRaise.svg';
import { ReactComponent as Networks } from '../../../Assets/icons/Networks.svg';
import { ReactComponent as Groups } from '../../../Assets/icons/Groups.svg';
import { ReactComponent as InfoHub } from '../../../Assets/icons/InfoHub.svg';
import { ReactComponent as Survey } from '../../../Assets/icons/Survey.svg';
import { ReactComponent as Service } from '../../../Assets/icons/Service.svg';
import { ReactComponent as Logout } from '../../../Assets/icons/LogOut.svg';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

import { Ref } from 'react';
interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
}

const SideNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const getFirstPath = pathname.split('/').filter((items: string) => items && items !== '');
  const is1980 = useMediaQuery('(max-width:1280px)');
  const [openInfoHub, setOpenInfoHub] = React.useState(false);
  const [snackOpen, setSnackOpen] = React.useState(false);

  const sideNavContents = [
    {
      icon: (isActive: boolean) => <Homeicon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    {
      icon: (isActive: boolean) => <Profileicon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'My Profile',
      link: routes.myProfile,
      name: 'my%20Profile',
    },
    {
      icon: (isActive: boolean) => <Feed className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Feed',
      link: routes.myFeed,
      name: 'my%20Feed',
    },
    {
      icon: (isActive: boolean) => <Events className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Events',
      link: routes.events,
      name: 'events',
    },
    {
      icon: (isActive: boolean) => <Jobs className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Jobs',
      link: routes.jobs,
      name: 'jobs',
    },
    {
      icon: (isActive: boolean) => <Jobs className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Placements',
      link: routes.placements,
      name: 'placements',
    },
    {
      icon: (isActive: boolean) => <MentorShip className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Mentorship',
      link: routes.mentorship,
      name: 'mentorship',
    },
    {
      icon: (isActive: boolean) => <FundRaise className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Fundraise',
      link: routes.fundraise,
      name: 'fundraise',
    },
    {
      icon: (isActive: boolean) => <Networks className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Network',
      link: routes.network,
      name: 'network',
    },
    {
      icon: (isActive: boolean) => <Groups className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Groups',
      link: routes.groups,
      name: 'groups',
    },
    {
      icon: (isActive: boolean) => <InfoHub className={classes.listItemIcon} />,
      label: 'Info Hub',
      name: 'infohub',
      isDropdown: true,
      children: [
        {
          label: 'Photos',
          link: routes.photos,
          name: 'photos',
          icon: (isActive: boolean) => <PermMediaOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
        },
        {
          label: 'Business directory',
          link: routes.businessdirectory,
          name: 'business%20directory',
          icon: (isActive: boolean) => <ComputerOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
        },
        {
          label: 'Resources',
          link: routes.resources,
          name: 'resources',
          icon: (isActive: boolean) => <Bookicon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
        },
      ],
    },
    {
      icon: (isActive: boolean) => <Survey className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Survey',
      link: routes.survey,
      name: 'survey',
    },
    {
      icon: (isActive: boolean) => <Service className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Service & Support',
      link: routes.service,
      name: 'service',
    },
    {
      icon: (isActive: boolean) => <Logout className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Logout',
      link: routes.login,
      name: 'logout',
    },
  ];
  const isInfoHubActive = sideNavContents.find((item: any) => item.isDropdown)?.children?.some((subItem: any) => getFirstPath[0] === subItem.name);
  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref: Ref<HTMLDivElement> // ✅ This fixes the type error
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleRestrictedClick = (link: string, index: number, name: string) => {
    if (name === 'Placements' || name === 'Logout') {
      handleListClick(link, index);
    } else {
      setSnackOpen(true);
    }
  };
  return (
    <>
      {is1980 ? (
        <div style={{ overflow: 'auto', height: `calc(100vh - 220px)` }} className="scrollbar-cusgray">
          {sideNavContents.map((item: any, index) => {
            if (item.isDropdown) {
              return (
                <div key={item.label}>
                  <ListItemButton onClick={() => setOpenInfoHub(!openInfoHub)} className={classes.listItemButton}>
                    {item.icon && <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>{item.icon(isInfoHubActive)}</ListItemIcon>}
                    <ListItemText primary={item.label} className={`${classes.listItemText}`} />
                    {openInfoHub ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>

                  <Collapse in={openInfoHub} timeout="auto" unmountOnExit>
                    {item.children.map((subItem: any) => {
                      const isSubItemActive = getFirstPath[0] === subItem.name;
                      return (
                        <ListItemButton
                          key={subItem.label}
                          onClick={() => handleRestrictedClick(subItem.link, index, subItem.label)}
                          className={`${classes.listItemButton} ${isSubItemActive && classes.listItemButtonActive}`}
                          sx={{ pl: 4 }}
                        >
                          {subItem.icon && (
                            <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
                              {subItem.icon(isSubItemActive)} {/* Render subheading icon */}
                            </ListItemIcon>
                          )}
                          <ListItemText primary={subItem.label} className={`${classes.listItemText} ${isSubItemActive && classes.listItemTextActive}`} />
                        </ListItemButton>
                      );
                    })}
                  </Collapse>
                </div>
              );
            } else {
              return (
                <ListItemButton
                  key={item.label}
                  onClick={() => handleRestrictedClick(item.link, index, item.label)}
                  className={`${classes.listItemButton} ${getFirstPath[0] === item.name && classes.listItemButtonActive}`}
                >
                  <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>{item.icon && item.icon(getFirstPath[0] === item.name)}</ListItemIcon>
                  <ListItemText primary={item.label} className={`${classes.listItemText} ${getFirstPath[0] === item.name && classes.listItemTextActive}`} />
                </ListItemButton>
              );
            }
          })}
        </div>
      ) : (
        <>
          <div style={{ overflow: 'auto', height: 'calc(100vh - 260px)' }} className="scrollbar-cusgray">
            {sideNavContents.slice(0, -1).map((item: any, index) => {
              if (item.isDropdown) {
                return (
                  <div key={item.label}>
                    <ListItemButton onClick={() => setOpenInfoHub(!openInfoHub)} className={classes.listItemButton}>
                      {item.icon && <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>{item.icon(isInfoHubActive)}</ListItemIcon>}
                      <ListItemText primary={item.label} className={`${classes.listItemText} ${isInfoHubActive && classes.listItemTextActive1}`} />
                      {openInfoHub ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>

                    <Collapse in={openInfoHub} timeout="auto" unmountOnExit>
                      {item.children.map((subItem: any) => {
                        const isSubItemActive = getFirstPath[0] === subItem.name;
                        return (
                          <ListItemButton
                            key={subItem.label}
                            onClick={() => handleRestrictedClick(subItem.link, index, subItem.label)}
                            className={`${classes.listItemButton} ${isSubItemActive && classes.listItemButtonActive}`}
                            sx={{ pl: 4 }}
                          >
                            {subItem.icon && (
                              <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
                                {subItem.icon(isSubItemActive)} {/* Render subheading icon */}
                              </ListItemIcon>
                            )}
                            <ListItemText primary={subItem.label} className={`${classes.listItemText} ${isSubItemActive && classes.listItemTextActive}`} />
                          </ListItemButton>
                        );
                      })}
                    </Collapse>
                  </div>
                );
              } else {
                return (
                  <ListItemButton
                    key={item.label}
                    onClick={() => handleRestrictedClick(item.link, index, item.label)}
                    className={`${classes.listItemButton} ${getFirstPath[0] === item.name && classes.listItemButtonActive}`}
                  >
                    <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>{item.icon && item.icon(getFirstPath[0] === item.name)}</ListItemIcon>
                    <ListItemText primary={item.label} className={`${classes.listItemText} ${getFirstPath[0] === item.name && classes.listItemTextActive}`} />
                  </ListItemButton>
                );
              }
            })}
          </div>
          <div>
            {/* Logout item */}
            {sideNavContents.slice(-1).map((item: any, index) => (
              <ListItemButton
                key={item.label}
                onClick={() => handleRestrictedClick(item.link, index, item.label)}
                style={{
                  marginTop: '0px',
                  position: 'absolute',
                  bottom: '0px',
                  marginBottom: '10px',
                }}
                className={`${classes.listItemButton} ${getFirstPath[0] === item.name && classes.listItemButtonActive}`}
              >
                <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>{item.icon && item.icon(getFirstPath[0] === item.name)}</ListItemIcon>
                <ListItemText primary={item.label} className={`${classes.listItemText} ${getFirstPath[0] === item.name && classes.listItemTextActive}`} />
              </ListItemButton>
            ))}
          </div>
        </>
      )}

      <Snackbar open={snackOpen} autoHideDuration={3000} onClose={() => setSnackOpen(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={() => setSnackOpen(false)} severity="info">
          You don’t have access to this section right now.
        </Alert>
      </Snackbar>
    </>
  );
};

export default SideNavTabs;
